export class ManipulateElement {
  borderTresholdMax = 20;
  borderTresholdMin = 2;

  constructor(selectorOrElement, triggerSelectorOrElement, closeSelectorOrElement) {
    this.id = parseInt((Math.random() * 10e7) + new Date().getMilliseconds(), 10);
    this.element = (typeof selectorOrElement === 'string') ? document.querySelector(selectorOrElement) : selectorOrElement;
    this.triggerElement = (typeof triggerSelectorOrElement === 'string') ? document.querySelector(triggerSelectorOrElement) : triggerSelectorOrElement;
    this.closeElement = (typeof closeSelectorOrElement === 'string') ? document.querySelector(closeSelectorOrElement) : closeSelectorOrElement;
    if (this.element) {
      this.initCSS();
      const temp = this.element.getBoundingClientRect();
      this.dimensions = {
        left: temp.left,
        top: temp.top,
        width: temp.width,
        height: temp.height
      };
      this.direction = null;
      this.mousePos = null;

      this.mouseMove.bind(this);
      this.triggerElement.addEventListener("pointerdown", evt => {
        if (evt.target === this.closeElement) {
          return true;
        }
        this.pointerId = evt.pointerId;
        this.triggerElement.setPointerCapture(this.pointerId);
        this.direction = null;
        
      });
      this.triggerElement.addEventListener("pointerup", evt => {
        try {
          this.triggerElement.releasePointerCapture(this.pointerId);
        } catch (e) {}
        this.pointerId = null;
        this.direction = null;
        this.triggerElement.style.cursor = 'grab';
      });
      this.triggerElement.addEventListener("mousemove", evt => {
        evt.preventDefault();
        this.mouseMove(evt);
      });
      this.endAltering.bind(this);
      this.triggerElement.addEventListener("touchend", this.endAltering);
      this.triggerElement.addEventListener("touchmove", evt => {
        const touch = evt.changedTouches[0];
        evt = {
          clientX: touch.clientX,
          clientY: touch.clientY,
          buttons: 1,
          shiftKey: false
        };
        this.mouseMove(evt);
        evt.preventDefault();
        return false;
      });
    } else {
      console.log(`ManipulateElement: Could not find element "${selectorOrElement}"`);
    }
  }

  initCSS() {
    const isTouchDevice =
      "ontouchstart" in window ||
      navigator.MaxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0;
    this.element.classList.add("ManipulateElement");
    let styles = document.getElementById("ManipulateElement");

    if (styles === null) {
      const temp = document.createElement("style");
      temp.setAttribute("id", "ManipulateElement");
      temp.innerHTML = `
      ${isTouchDevice ? "* { user-select: none;}" : ""}

      .touch-device .info-touch { ${
        isTouchDevice
          ? "display: block; color: red; font-weight: bold;"
          : "display: none;"
      }}
      `;
      styles = document.body.appendChild(temp);
      document.body.classList.add("touch-device");
    }

    this.useMargin =
      ["absolute", "relative", "fixed"].indexOf(
        getComputedStyle(this.element).position.toLowerCase()
      ) === -1;
  }

  change(property, value) {
    this.element.style[property] = `${value}px`;
  }

  mouseMove({ clientX, clientY, buttons }) {
    this.triggerElement.style.cursor = "move";

    if (buttons === 1) {
      if (!document.body.classList.contains('altering')) document.body.classList.add("altering");
      if (!this.element.classList.contains('not-locked')) this.element.classList.add("not-locked");
      const changeX = this.mousePos ? this.mousePos.clientX - clientX : 0;
      const changeY = this.mousePos ? this.mousePos.clientY - clientY : 0;
      this.mousePos = { clientX, clientY };

      const newTop = this.dimensions.top - changeY;
      const newLeft = this.dimensions.left - changeX;

      const prefix = this.useMargin ? "margin-" : "";
      // Move rectangle
      this.dimensions.left = newLeft;
      this.element.style[`${prefix}left`] = `${newLeft}px`;
      this.dimensions.top = newTop;
      this.element.style[`${prefix}top`] = `${newTop}px`;
    } else {
      this.endAltering();
    }

    this.mousePos = { clientX, clientY };
  }

  endAltering() {
    document.body.classList.remove("altering");
    this.element.classList.remove("not-locked");
  }
}
